import { sf_hinhthucmiengiam_group } from "../../models/response/hinh-thuc-mien-giam/sf_hinhthucmiengiam_group"

export enum HinhThucMienGiamGroupActionTypeIds {
    HINHTHUCMIENGIAMGROUP_LOAD_START = "HINHTHUCMIENGIAMGROUP_LOAD_START",
    HINHTHUCMIENGIAMGROUP_LOAD_SUCCESS = "HINHTHUCMIENGIAMGROUP_LOAD_SUCCESS",
    HINHTHUCMIENGIAMGROUP_LOAD_ERROR = "HINHTHUCMIENGIAMGROUP_LOAD_ERROR",

    HINHTHUCMIENGIAMGROUP_SHOW_DETAIL_MODAL = "HINHTHUCMIENGIAMGROUP_SHOW_DETAIL_MODAL",
    HINHTHUCMIENGIAMGROUP_SHOW_DELETE_CONFIRM = "HINHTHUCMIENGIAMGROUP_SHOW_DELETE_CONFIRM",
    HINHTHUCMIENGIAMGROUP_CLOSE_DETAIL_MODAL = "HINHTHUCMIENGIAMGROUP_CLOSE_DETAIL_MODAL",

    HINHTHUCMIENGIAMGROUP_SAVE_START = "HINHTHUCMIENGIAMGROUP_SAVE_START",
    HINHTHUCMIENGIAMGROUP_SAVE_SUCCESS = "HINHTHUCMIENGIAMGROUP_SAVE_SUCCESS",
    HINHTHUCMIENGIAMGROUP_SAVE_ERROR = "HINHTHUCMIENGIAMGROUP_SAVE_ERROR",

    HINHTHUCMIENGIAMGROUP_DELETE_START = "HINHTHUCMIENGIAMGROUP_DELETE_START",
    HINHTHUCMIENGIAMGROUP_DELETE_SUCCESSS = "HINHTHUCMIENGIAMGROUP_DELETE_SUCCESSS",
    HINHTHUCMIENGIAMGROUP_DELETE_ERROR = "HINHTHUCMIENGIAMGROUP_DELETE_ERROR",

    HINHTHUCMIENGIAMGROUP_CHANGE_SELECTED_IDS = "HINHTHUCMIENGIAMGROUP_CHANGE_SELECTED_IDS"

}

export interface HinhThucMienGiamGroupLoadStartAction {
    type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_LOAD_START
}
export interface HinhThucMienGiamGroupLoadSuccessAction {
    type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_LOAD_SUCCESS,
    payload: sf_hinhthucmiengiam_group[]
}
export interface HinhThucMienGiamGroupLoadErrorAction {
    type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_LOAD_ERROR,
    payload: string
}

export interface HinhThucMienGiamGroupShowDetailModalAction {
    type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_SHOW_DETAIL_MODAL,
    payload?: sf_hinhthucmiengiam_group

}
export interface HinhThucMienGiamGroupShowDeleteConfirmAction {
    type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_SHOW_DELETE_CONFIRM,
    payload: boolean
}
export interface HinhThucMienGiamGroupCloseDetailModalAction {
    type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_CLOSE_DETAIL_MODAL,
}
export interface HinhThucMienGiamGroupSaveStartAction {
    type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_SAVE_START,
    payload: sf_hinhthucmiengiam_group
}
export interface HinhThucMienGiamGroupSaveSuccessAction {
    type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_SAVE_SUCCESS,
    payload: sf_hinhthucmiengiam_group
}
export interface HinhThucMienGiamGroupSaveErrorAction {
    type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_SAVE_ERROR,
    payload: string
}
export interface HinhThucMienGiamGroupDeleteStartAction {
    type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_DELETE_START,
    payload: number[]
}
export interface HinhThucMienGiamGroupDeleteSuccessAction {
    type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_DELETE_SUCCESSS,
    payload: number[]
}
export interface HinhThucMienGiamGroupDeleteErrorAction {
    type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_DELETE_ERROR,
    payload: string
}

export interface HinhThucMienGiamGroupChangeSelectedIdsAction {
    type: HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_CHANGE_SELECTED_IDS,
    payload: number[]
}
export type HinhThucMienGiamGroupActionTypes =
    HinhThucMienGiamGroupLoadStartAction | HinhThucMienGiamGroupLoadSuccessAction | HinhThucMienGiamGroupLoadErrorAction |
    HinhThucMienGiamGroupShowDetailModalAction | HinhThucMienGiamGroupShowDeleteConfirmAction |
    HinhThucMienGiamGroupSaveStartAction | HinhThucMienGiamGroupSaveSuccessAction | HinhThucMienGiamGroupSaveErrorAction |
    HinhThucMienGiamGroupDeleteStartAction | HinhThucMienGiamGroupDeleteSuccessAction | HinhThucMienGiamGroupDeleteErrorAction |
    HinhThucMienGiamGroupChangeSelectedIdsAction | HinhThucMienGiamGroupCloseDetailModalAction